import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/global/Header";
import Collection from "./Collection"
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect,useMemo } from 'react';
import { getCollections } from "../../slices/collection";



const Collections = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);

  const collections = useSelector((state) => state.collection.data.list);

  useEffect(() => {

    dispatch(getCollections({page,pageSize}));

  }, [page,pageSize]);

  return (
    <Box m="20px">

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="Collections" subtitle="Welcome to your Collections" />
      </Box>

      {/* GRID */}
      <Box
      justifyContent="flex-start"
        margin="0 auto"
        display="grid"
        gridTemplateColumns="repeat(auto-fill, 500px)"

        rowGap="20px"
        columnGap="20px"
      >
      
      {collections &&
        collections.map((collection) => (
            <Collection collection={collection} key={collection.id} />
          ))
      }


      </Box>
    </Box>
  );
};

export default Collections;
